import { combineReducers } from "redux";

import authReducer from "./authReducer";
import packageReducer from "./packageReducer";
import articleReducer from "./articleReducer";
import profileReducer from "./profileReducer";
import clientReducer from "./clientReducer";
import userReducer from "./userReducer";
import errorReducer from "./errorReducer";

export default combineReducers({
  package: packageReducer,
  article: articleReducer,
  profile: profileReducer,
  client: clientReducer,
  user: userReducer,
  errors: errorReducer,
  auth: authReducer,
});
